/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface DisplayUser
 */
export interface DisplayUser {
    /**
     * 
     * @type {string}
     * @memberof DisplayUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayUser
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisplayUser
     */
    authProviders: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DisplayUser
     */
    authProviderId: string;
    /**
     * 
     * @type {Array<Role>}
     * @memberof DisplayUser
     */
    roles: Array<Role>;
    /**
     * 
     * @type {string}
     * @memberof DisplayUser
     */
    invitation?: string | null;
}

/**
 * Check if a given object implements the DisplayUser interface.
 */
export function instanceOfDisplayUser(value: object): value is DisplayUser {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('authProviders' in value) || value['authProviders'] === undefined) return false;
    if (!('authProviderId' in value) || value['authProviderId'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function DisplayUserFromJSON(json: any): DisplayUser {
    return DisplayUserFromJSONTyped(json, false);
}

export function DisplayUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayUser {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'authProviders': json['authProviders'],
        'authProviderId': json['authProviderId'],
        'roles': ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'invitation': json['invitation'] == null ? undefined : json['invitation'],
    };
}

export function DisplayUserToJSON(value?: DisplayUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'name': value['name'],
        'authProviders': value['authProviders'],
        'authProviderId': value['authProviderId'],
        'roles': ((value['roles'] as Array<any>).map(RoleToJSON)),
        'invitation': value['invitation'],
    };
}

